import { render, staticRenderFns } from "./Recieve.vue?vue&type=template&id=ed47eda2"
import script from "./Recieve.vue?vue&type=script&lang=js"
export * from "./Recieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports